import React, { useEffect, useRef } from 'react';
import { Flex, Typography } from "antd";
const { Text, Paragraph, Link } = Typography;

import { ModalErroBotoesCustomizados } from '../../../../../components/Modais/ModalErro';
import { ModalSucessoBotoesCustomizados } from '../../../../../components/Modais/ModalSucesso';
import { ModalConfirmacaoBotoesCustomizados } from '../../../../../components/Modais/ModalConfirmacao';
import { StatusModalBloquearDesbloquearEntrada } from 'constants/constantesBloquearDesbloquearEntradaUsuario';

export default function BloquearDesbloquearEntrada({
  userId,
  mensagem,
  modalControl,
  contaEstaAtiva,
  tituloModalConfirmacao,
  descricaoModalConfirmacao,
  labelBotaoAcaoModalConfirmacao,
  executarAcao,
  definirComportamentoAoFecharModal
}) {

  const ultimoModalControl = useRef(null);

  useEffect(() => {
    if (!userId) return;
    if (ultimoModalControl.current === modalControl) return; // já disparou, não faz nada
    ultimoModalControl.current = modalControl;

    switch (modalControl) {
      case StatusModalBloquearDesbloquearEntrada.SUCESSO:
        ModalSucessoBotoesCustomizados({
          onClickAcao: definirComportamentoAoFecharModal,
          conteudo: (<Text>{mensagem}</Text>),
          titulo:
            (
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <Text strong>Sucesso!</Text>
              </div>
            ),
        });
        break;

      case StatusModalBloquearDesbloquearEntrada.ERRO:
        ModalErroBotoesCustomizados({
          mensagem,
          onClickAcao: definirComportamentoAoFecharModal,
          labelBotaoOk: "Fechar",
          titulo: (
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Text strong>Erro</Text>
            </div>
          ),
          conteudo: (
            <div>
              <Paragraph style={{ marginBottom: 12 }}>{mensagem}</Paragraph>
              <Paragraph>
                Tente novamente ou entre em contato com o suporte:<br />
                <Link href="mailto:atendimento@bhs.com.br">atendimento@bhs.com.br</Link><br />
                <Link href="tel:4000-1744">4000-1744 – opção 1</Link>
              </Paragraph>
            </div>
          )
        });
        break;

      case StatusModalBloquearDesbloquearEntrada.CONFIRMACAO:
        ModalConfirmacaoBotoesCustomizados({
          onClickAcao: executarAcao,
          labelBotaoAcao: labelBotaoAcaoModalConfirmacao,          
          onClickCancelar: definirComportamentoAoFecharModal,
          conteudo: (
            <Flex vertical>
              <Text>{descricaoModalConfirmacao}</Text>
            </Flex>
          ),
          tipoBotaoAcao: contaEstaAtiva ? "danger" : "primary",
          titulo: (<Text strong>{tituloModalConfirmacao}</Text>)
        });
        break;

      default:
        break;
    }
  }, [
    modalControl
  ]);

  return null;
}
